export function allowEmptyString(wrappedPropTypes) {
    return (props, propName, ...rest) => {
        if (props[propName] === "") {
            return null
        }
        return wrappedPropTypes(props, propName, ...rest)
    }
}